import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import { InductionService } from "../induction.service";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: 'app-view-induction',
  templateUrl: './view-induction.component.html',
  styleUrls: ['./view-induction.component.scss']
})
export class ViewInductionComponent implements OnInit, OnDestroy {
  private _destroyed$ = new Subject<void>();

  induction: any = null;
  isLoading: boolean = true;

  // Expanded state for each field
  expandedFields: { [key: string]: boolean } = {};

  constructor(
    private route: ActivatedRoute,
    private inductionService: InductionService
  ) {}

  ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get('id');

    if (id) {
      this.inductionService.getDataById(id).pipe(takeUntil(this._destroyed$)).subscribe(data => {
        this.induction = data ?? null;
        console.log("Fetched Induction Data:", this.induction);
        this.isLoading = false;
      });
    }
  }

  getTruncatedText(text: string = '', charLimit: number = 40): string {
    if (!text) return 'N/A';
    if (text.length <= charLimit) return text;
    return text.substring(0, charLimit) + '...';
  }

  shouldShowMoreButton(text: string = '', charLimit: number = 40): boolean {
    if (!text) return false;
    return text.length > charLimit;
  }

  toggleExpanded(key: string): void {
    this.expandedFields[key] = !this.expandedFields[key];
  }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }
}
